import partnerDedupEn from 'src/composites/PartnerDedup/i18n/en'
import partnerDedupFr from 'src/composites/PartnerDedup/i18n/fr'
import workDayManagerEn from 'src/composites/WorkDayManager/i18n/en'
import workDayManagerFr from 'src/composites/WorkDayManager/i18n/fr'
export default {
  en: {
    units: { unit: 'Unit', packageOf: 'Package of {count}', length: { in: 'Inches', ft: 'Feet', m: 'Metres', cm: 'Centimetres' } },
    welcome: 'Hi, {name}',
    welcome_caption: '{active} active tasks and {completed} completed tasks',
    composites: {
      PartnerDedup: partnerDedupEn,

      WorkDayManager: workDayManagerEn,
    },
    localstorage_reset: {
      title: 'Remote app reset incoming',
      message:
        '<b>{admin}</b> is remotely fixing an issue with your app. Your local data (except login and app settings) will be cleared and the page will reload in <b>{seconds}</b> seconds. Save any unsaved work now.',
      ok_now: 'Reset now',
      unknown_admin: 'An administrator',
    },
  },
  fr: {
    units: { unit: 'Unité', packageOf: 'Paquet de {count}', length: { in: 'Pouces', ft: 'Pieds', m: 'Mètres', cm: 'Centimètres' } },
    welcome: 'Bonjour, {name}',
    welcome_caption: '{active} tâches actives et {completed} tâches terminées',
    composites: {
      PartnerDedup: partnerDedupFr,

      WorkDayManager: workDayManagerFr,
    },
    localstorage_reset: {
      title: "Réinitialisation à distance de l'application",
      message:
        "<b>{admin}</b> corrige un problème sur votre application à distance. Vos données locales (sauf la connexion et les préférences) seront effacées et la page rechargera dans <b>{seconds}</b> secondes. Sauvegardez votre travail maintenant.",
      ok_now: 'Réinitialiser maintenant',
      unknown_admin: 'Un administrateur',
    },
  },
}
